import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import PlanSelection from '../../pages/Experience/components/PlanSelection';
import { t } from 'i18next';
import logo from '../../assets/teaboy/logo.png';
export const PlanUpgradeModal = ({ isOpen, toggle }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
            <ModalHeader toggle={toggle} className="">
                <div className="d-flex align-items-center gap-2">
                    <img style={{ width: '32px' }} src={logo} />
                    <span className="fw-bold">{t("Upgrade Your Plan")}</span>
                </div>
            </ModalHeader>
            <ModalBody className="p-0">
                <div style={{ fontSize: "16px" }} className='my-5 d-flex flex-column align-items-center gap-2'>
                    <p className='text-center '>You need to upgrade your plan to proceed.
                    </p>
                    <p className='text-center '> Please contact the admin for more details</p>
                    <a href='mailto:contact@clickorder.io' className='text-center text-decoration-none'>contact@clickorder.io</a>
                </div>
                {/* <div className="px-3">
                    <PlanSelection isCompact={true} />
                </div> */}
            </ModalBody>
        </Modal>
    );
};
